import { Box, Checkbox, Menu, MenuItem, Typography } from '@mui/material';

const uncheckedIcon = (
    <span
        style={{
            width: 20,
            height: 20,
            borderRadius: 4,
            border: '2px solid #E6E6E6',
            background: '#FFF',
            display: 'block',
            boxSizing: 'border-box',
            boxShadow: '0px 2px 3px rgba(0,0,0,0.06)',
        }}
    />
);

const styles = {
    paper: {
        width: 193,
        borderRadius: '8px',
        overflow: 'hidden',
        background: '#FFF',
        boxShadow: '0px 3px 14px 2px rgba(0,0,0,0.12), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 5px 5px -3px rgba(0,0,0,0.20)',
    },

    titleRow: {
        padding: '16px',
        borderBottom: '1px solid rgba(0,0,0,0.10)',
        cursor: 'default',
        color: '#000',

        fontSize: '16px',
        fontWeight: '600',
        lineHeight: 'normal',
        textTransform: 'capitalize',

        '&:hover': {
            backgroundColor: 'transparent',
        },
    },

    menuItem: {
        padding: '8px 16px ',
        minHeight: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        alignSelf: 'stretch',

        '&:hover': {
            backgroundColor: '#F5F5F5',
        },
    },

    checkboxRow: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        gap: '8px',
    },
};

const ManageColumnsMenu = ({ anchorEl, open, onClose, columns = [] }) => {
    const handleToggle = (column) => {
        if (typeof column.onToggle === 'function') column.onToggle(!column.checked);
    };

    return (
        <Menu
            anchorEl={anchorEl}
            open={!!open}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            MenuListProps={{
                disablePadding: true,
            }}
            sx={{
                '& .MuiPaper-root': {
                    width: 193,
                    borderRadius: '8px',
                    overflow: 'hidden',
                    background: '#FFF',
                    boxShadow: '0px 3px 14px 2px rgba(0,0,0,0.12), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 5px 5px -3px rgba(0,0,0,0.20)',
                },
            }}
        >
            <MenuItem disableRipple disableGutters sx={styles.titleRow}>
                Customize Columns
            </MenuItem>

            {columns.map((col) => (
                <MenuItem
                    key={col.key || col.label}
                    disableRipple
                    onClick={() => handleToggle(col)}
                    sx={styles.menuItem}
                    style={{ marginBottom: col.key === 'unit' ? '4px' : '0px' }}
                >
                    <Box sx={styles.checkboxRow}>
                        <Checkbox
                            checked={!!col.checked}
                            disableRipple
                            size="small"
                            onChange={() => handleToggle(col)}
                            icon={uncheckedIcon}
                            sx={{
                                p: 0,
                                m: 0,
                                width: 20,
                                height: 20,
                                flexShrink: 0,
                                '& .MuiSvgIcon-root': {
                                    fontSize: 20,
                                },
                            }}
                        />
                        <Typography
                            sx={{
                                m: 0,
                                color: 'rgba(0, 0, 0, 0.87)',
                                fontFamily: 'Roboto',
                                fontSize: '14px',
                                fontStyle: 'normal',
                                fontWeight: 400,
                                lineHeight: '24px',
                                textTransform: 'capitalize',
                            }}
                        >
                            {col.label}
                        </Typography>
                    </Box>
                </MenuItem>
            ))}
        </Menu>
    );
};

export default ManageColumnsMenu;
